import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { product, ProductManipulationViewModel } from "./productManipulation-viewModel"

export class ProductManipulationView extends View<ProductManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-BA77903F-D95D-43A6-BD10-0C81D9ABC832"
    }
    loadHtml(): string {
        let element = require('./productManipulation.html').default;
        let style = require('./productManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set products(v: ObservableArray<product>) { this._products = v; } public get products(): ObservableArray<product> { return this._products;} private _products: ObservableArray<product>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set fileSelectorForIndex(v: FileSelectorViewModel) { this._fileSelectorForIndex = v; } public get fileSelectorForIndex(): FileSelectorViewModel { return this._fileSelectorForIndex;} private _fileSelectorForIndex: FileSelectorViewModel;
    
    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }
    
    importProductIndex() {
        this.dataContext.importProductIndex();
    }
    
    exportProductIndex() {
        this.dataContext.exportProductIndex();
    }

    requestProductCreation(){
        this.dataContext.requestProductCreation();
    }

}
